//----------------------------------------USER-DETAILS--------------------------------------------------------------------------------------------
export const USER_DETAILS = "USER_DETAILS";
export const USER_DETAILS_PENDING = "USER_DETAILS_PENDING";
export const USER_DETAILS_SUCCESS = "USER_DETAILS_SUCCESS";
export const USER_DETAILS_ERROR = "USER_DETAILS_ERROR";
export const CLEAR_USER_DETAILS_ERROR = "CLEAR_USER_DETAILS_ERROR";

//----------------------------------------USER-UPDATE--------------------------------------------------------------------------------------------
export const CLOSE_EDIT_USER_MODAL = "CLOSE_EDIT_USER_MODAL";
export const OPEN_EDIT_USER_MODAL = "OPEN_EDIT_USER_MODAL";
export const UPDATE_USER_PENDING = "UPDATE_USER_PENDING";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_ERROR = "UPDATE_USER_ERROR";
export const CLEAR_UPDATE_USER_ERROR = "CLEAR_UPDATE_USER_ERROR";

//----------------------------------------RESET-PASSWORD--------------------------------------------------------------------------------------------
export const SEND_RESET_PASSWORD_PENDING = "SEND_RESET_PASSWORD_PENDING";
export const SEND_RESET_PASSWORD_SUCCESS = "SEND_RESET_PASSWORD_SUCCESS";
export const SEND_RESET_PASSWORD_ERROR = "SEND_RESET_PASSWORD_ERROR";
export const CLEAR_SEND_RESET_PASSWORD_ERROR = "CLEAR_SEND_RESET_PASSWORD_ERROR";

//----------------------------------------CHANGE-PASSWORD--------------------------------------------------------------------------------------------
export const OPEN_CHANGE_PASSWORD_MODAL = "OPEN_CHANGE_PASSWORD_MODAL";
export const CLOSE_CHANGE_PASSWORD_MODAL = "CLOSE_CHANGE_PASSWORD_MODAL";
export const CHANGE_PASSWORD_PENDING = "CHANGE_PASSWORD_PENDING";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";
export const CLEAR_CHANGE_PASSWORD_ERROR = "CLEAR_CHANGE_PASSWORD_ERROR";
export const CHANGE_PASSWORD_FORM = "CHANGE_PASSWORD_FORM"

//----------------------------------------TRANSFER-DEVICES--------------------------------------------------------------------------------------------
export const CLOSE_TRANSFER_DEVICE_MODAL = "CLOSE_TRANSFER_DEVICE_MODAL";
export const OPEN_TRANSFER_DEVICE_MODAL = "OPEN_TRANSFER_DEVICE_MODAL";
export const TRANSFER_DEVICE_PENDING = "TRANSFER_DEVICE_PENDING";
export const TRANSFER_DEVICE_SUCCESS = "TRANSFER_DEVICE_SUCCESS";
export const TRANSFER_DEVICE_ERROR = "TRANSFER_DEVICE_ERROR";
export const CLEAR_TRANSFER_DEVICE_ERROR = "CLEAR_TRANSFER_DEVICE_ERROR";
export const SET_ASSIGNABLE_TRANSFER_USERS_LIST_ASYNC = "SET_ASSIGNABLE_TRANSFER_USERS_LIST_ASYNC";
export const SET_SUBORDINATES_USERS_LIST_ASYNC = "SET_SUBORDINATES_USERS_LIST_ASYNC";
export const TRANSFER_USER_PENDING = "TRANSFER_USER_PENDING";
export const TRANSFER_USER_SUCCESS = "TRANSFER_USER_SUCCESS";
export const TRANSFER_USER_ERROR = "TRANSFER_USER_ERROR";
export const CLEAR_TRANSFER_USER_ERROR = "CLEAR_TRANSFER_USER_ERROR";
export const TRASFER_USERS_FORM = "TRASFER_USERS_FORM"

//-----------------------------------------------------ORG-PREFERENCE---------------------------------------------------------------------------------
export const SET_LOADING = "SET_LOADING"
export const ORG_PREFERENCE = "ORG_PREFERENCE"
export const OPEN_ORG_PREFERENCE = "OPEN_ORG_PREFERENCE"
export const CLOSE_ORG_PREFERENCE = "CLOSE_ORG_PREFERENCE"
export const UPDATE_ORG_PREFERENCE_ERROR = "UPDATE_ORG_PREFERENCE_ERROR"
export const CLEAR_UPDATE_ORG_PREFERENCE_ERROR = "CLEAR_UPDATE_ORG_PREFERENCE_ERROR"

//-----------------------------------------------------DIRECT-PASSWORD-FORM---------------------------------------------------------------------------------
export const DIRECT_CHANGE_PASSWORD_FORM = "DIRECT_CHANGE_PASSWORD_FORM";
export const OPEN_DIRECT_CHANGE_PASSWORD_MODAL = "OPEN_DIRECT_CHANGE_PASSWORD_MODAL";
export const CLOSE_DIRECT_CHANGE_PASSWORD_MODAL = "CLOSE_DIRECT_CHANGE_PASSWORD_MODAL";
export const DIRECT_CHANGE_PASSWORD_PENDING = "DIRECT_CHANGE_PASSWORD_PENDING";
export const DIRECT_CHANGE_PASSWORD_ERROR = "DIRECT_CHANGE_PASSWORD_ERROR";
export const CLEAR_DIRECT_CHANGE_PASSWORD_ERROR = "CLEAR_DIRECT_CHANGE_PASSWORD_ERROR";

//----------------------------------------DELETE-SELF-ACCOUNT--------------------------------------------------------------------------------------------
export const DELETE_SELF_ACCOUNT_PENDING = "DELETE_SELF_ACCOUNT_PENDING";
export const DELETE_SELF_ACCOUNT_ERROR = "DELETE_SELF_ACCOUNT_ERROR";
export const CLEAR_DELETE_SELF_ACCOUNT_ERROR = "CLEAR_DELETE_SELF_ACCOUNT_ERROR";

//----------------------------------------DELETE-OTHERS-ACCOUNT--------------------------------------------------------------------------------------------
export const DELETE_OTHERS_ACCOUNT_PENDING = "DELETE_OTHERS_ACCOUNT_PENDING";
export const DELETE_OTHERS_ACCOUNT_ERROR = "DELETE_OTHERS_ACCOUNT_ERROR";
export const CLEAR_DELETE_OTHERS_ACCOUNT_ERROR = "CLEAR_DELETE_OTHERS_ACCOUNT_ERROR";

